import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    template: `
        <p-field [label]="label" [isReadOnly]="true">
            <div slot="readMode">
                <p-partial-list [valuesList]="value" [numOfValuesToShow]="numOfVariablesToShow"></p-partial-list>
            </div>
        </p-field>
    `,
    selector: 'p-field-partial-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldPartialListComponent
        }
    ]
})
export class PFieldPartialListComponent extends PFieldAbstractComponent<string[] | number[]> {
    @Input() public label: string = '';
    @Input() public numOfVariablesToShow: number = 0;
}
